import axios from "axios";
import dayjs from "dayjs";
import md5 from "js-md5";
import { decrypt } from "@/utils/commonUtils.js";

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_NICE_API,
  withCredentials: true,
  headers: {
    // "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  // responseType: "document",
  timeout: 50000, // request timeout 50s
});

// request interceptor
service.interceptors.request.use(
  config => {
    const type = config.method === "post" ? "data" : "params";
    if (!config[type]) config[type] = {};
    const apiKeyOrigin = decrypt(process.env.VUE_APP_NICE_API_KEY);
    config[type].apikey = md5(apiKeyOrigin + dayjs().format("YYYYMMDD"));

    // URL이 'taxprove.nice'로 끝나는 경우 responseType을 'document'로 설정
    if (config.url && config.url.endsWith("taxprove.nice")) {
      config.responseType = "document";
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

export default service;
